import { css } from 'emotion';

import { colors } from '@cobliteam/base-components/src/styles/colors';
import { fonts } from '@cobliteam/base-components/src/styles/fonts';

export const toggle = css`
  height: 100%;
  && {
    width: 100%;
    margin-right: 0px;
  }

  & > button {
    padding: 8.5px 9px;
  }

  input[type="checkbox"] {
    position: absolute;
    width: 300%;
    height: 100%;
  }

  &:not(:first-child) {
    margin-top: 10px;
  }
`;

export const text = css`
  padding-left: 10px;
  display: inline-flex;
  font-weight: ${fonts.weight.bold};
`;

export const mediaText = (mediaEventsFeatureFlag: boolean) => css`
  ${text}
  color: ${mediaEventsFeatureFlag ? colors.gray.dark : colors.gray.default};
`;

export const textWithTooltipWrapper = css`
  display: inline-flex;
  gap: 5px;
`;

export const wrapper = css`
  background-color: ${colors.white};
  padding: 10px;
  border: 1px solid ${colors.gray.light};
  box-shadow: 0 0 10px 0 ${colors.custom.gray20};
`;

export const tooltip = css`
  margin-left: 6.33px;
`;

export const tooltipBody = css`
  max-width: 300px;
`;

export const tooltipTitle = css`
  margin-bottom: 10px;
`;
